import { render, staticRenderFns } from "./BlogReviewsTab.vue?vue&type=template&id=2bb57b06"
import script from "./BlogReviewsTab.vue?vue&type=script&lang=js"
export * from "./BlogReviewsTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports